import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionTag, SectionHeading } from "@/components/landing/Reveal";
import { useLang } from "@/lib/i18n";

export default function Faq({ faq }) {
  const { t, dyn } = useLang();
  const items = faq?.items?.length ? faq.items : t("faq.items");
  const tag = faq?.tag ? dyn(faq.tag) : t("faq.tag");
  const heading = faq?.heading ? dyn(faq.heading) : t("faq.heading");
  const sub = faq?.sub ? dyn(faq.sub) : t("faq.sub");
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="bg-ink py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionTag number="08" label={tag} />
        <div className="grid gap-12 lg:grid-cols-[1fr_1.4fr]">
          <div>
            <SectionHeading>{heading}</SectionHeading>
            <Reveal delay={0.15}>
              <p className="mt-6 max-w-sm text-base leading-relaxed text-fog">{sub}</p>
            </Reveal>
          </div>
          <div className="divide-y divide-white/10 border-y border-white/10">
            {items.map((item, i) => (
              <Reveal key={item.q} delay={0.05 + i * 0.06}>
                <div data-testid={`faq-item-${i}`}>
                  <button
                    data-testid={`faq-toggle-${i}`}
                    onClick={() => setOpen(open === i ? -1 : i)}
                    aria-expanded={open === i}
                    className="flex w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <h3 className="font-display text-base font-bold tracking-tight text-bone sm:text-lg">{dyn(item.q)}</h3>
                    <Plus
                      className={`h-5 w-5 shrink-0 text-mint transition-transform duration-300 ${open === i ? "rotate-45" : ""}`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {open === i && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pb-6 text-sm leading-relaxed text-fog sm:text-base">{dyn(item.a)}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
